export default {
  gameTypes: {
    badugi: 'Badugi',
    courchevel: 'Courchevel',
    'deuce-to-seven': '2-7 Triple Draw',
    'five-card-draw': '5 Card Draw',
    'five-card-omaha': '5 Card Omaha',
    'five-card-omaha-hi-lo': '5 Card Omaha H/L',
    'four-card-omaha': 'Omaha',
    'four-card-omaha-hi-lo': 'Omaha H/L',
    holdem: "Hold'em",
    razz: 'Razz',
    'seven-card-stud': 'Stud',
    'seven-card-stud-hi-lo': 'Stud H/L',
    unknown: 'Unknown',
    mixed: 'Mixed',
    'holdem-six-plus': "6+ Hold'em"
  },
  handUpload: {
    errors: {
      notPsHand: {
        apiError: 'Hand does not appear to be a valid PokerStars hand',
        title: 'Please paste a valid hand history',
        messageHtml: '<p>Hand does not appear to be a valid PokerStars hand.</p> <p><a href="/help">Instructions for obtaining a valid hand can be found in the knowledgebase</a></p>'
      },
      incompleteHistory: {
        apiError: 'Incomplete hand history',
        title: 'Please paste a valid hand history',
        messageHtml: '<p>It looks like you have not pasted all of the hand history, please paste the complete hand history including the summary.<p> <p><a href="/help">Instructions for uploading a hand can be found in the knowledgebase</a></p>'
      },
      serverError: {
        apiError: 'An unknown error occurred',
        title: 'An unknown error occurred',
        messsageHtml: '<p>An unknown server error occurred while uploading the hand</p>'
      },
      parseFailed: {
        apiError: 'Parse failed',
        title: 'We were unable to parse that hand history',
        messageHtml: '<p><a href="/help">Instructions for obtaining a valid hand can be found in the knowledgebase</a></p>'
      }
    }
  },
  replayer: {
    streetLabels: {
      preflop: 'Pre-flop',
      spit: 'Spit',
      flop: 'Flop',
      turn: 'Turn',
      river: 'River',
      showdown: 'Showdown',
      preDraw: 'Pre-draw',
      firstDraw: '1st draw',
      secondDraw: '2nd draw',
      thirdDraw: '3rd draw',
      draw: 'Draw',
      third: '3rd',
      fourth: '4th',
      fifth: '5th',
      sixth: '6th',
      seventh: '7th'
    }
  }
}
